export const DISCOVER_CARDS = [
    {
      title: '100% Dealer Support',
      content:
        'We work like your extended team—sales help, issue resolution, and constant backup whenever you need it.',
    },
    {
      title: 'Strong & Long-lasting Products',
      content:
        'We grow together, not transact once—built on trust, consistency, and mutual profitability.',
    },
    {
      title: 'Clear MRP Pricing',
      content:
        "Transparent pricing with no confusion, no undercutting—so your margins stay protected.",
    },
    {
      title: 'Ready Stock',
      content:
        'Fast-moving sizes always available, helping you close sales without waiting or excuses.',
    },
    {
      title: '24 Hour Delivery (TN)',
      content:
        'Orders move fast—most deliveries dispatched within 24 hours to keep your business running.',
    },
    {
      title: 'Technical Assistance',
      content:
        'Right product for the right application—our team helps you and your customers choose correctly.',
    },
  ];